import { siteContent } from "./siteContent";

export default function App() {
  return (
    <main className="min-h-screen bg-[#f7f3ed] text-[#1e2420]">
      <section className="hero">
        <div className="hero__copy">
          <div className="brand">
            <img src="/icon-tipbook.webp" alt="" className="brand__icon" />
            <span>{siteContent.appName}</span>
          </div>

          <p className="eyebrow">{siteContent.category}</p>
          <h1>{siteContent.headline}</h1>
          <p className="body">{siteContent.body}</p>

          <div className="actions" aria-label="Download options">
            <a className="primary" href={siteContent.appStoreUrl}>
              <svg className="appstore__logo" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              <span className="appstore__text">
                <small>Download on the</small>
                <strong>App Store</strong>
              </span>
            </a>
            <a className="primary" href={siteContent.playStoreUrl}>
              <svg className="appstore__logo" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M3 20.5V3.5c0-.59.34-1.11.84-1.35L13.69 12 3.84 21.85c-.5-.25-.84-.76-.84-1.35m13.81-5.38L6.05 21.34l8.49-8.49 2.27 2.27M20.16 10.81c.34.27.59.69.59 1.19 0 .5-.22.9-.57 1.18l-2.29 1.32-2.5-2.5 2.5-2.5 2.27 1.31M6.05 2.66l10.76 6.22-2.27 2.27L6.05 2.66Z" />
              </svg>
              <span className="appstore__text">
                <small>Get it on</small>
                <strong>Google Play</strong>
              </span>
            </a>
          </div>

          <dl className="proof">
            {siteContent.proofPoints.map((point) => (
              <div key={point}>
                <dt>{point}</dt>
              </div>
            ))}
          </dl>

          <p className="support">
            <a href={`mailto:${siteContent.supportEmail}`}>
              Contact us
            </a>
          </p>
        </div>

        <div className="hero__visual" aria-label="Tipbook app screenshot preview">
          <div className="phone">
            <div className="phone__status" />
            <img
              className="screen"
              src="/tipbook-android-screenshot-2x.webp"
              alt="Tipbook app home screen"
            />
          </div>
        </div>
      </section>
    </main>
  );
}
